import { Tv, Bot, LogOut } from "lucide-react";

const MODE_LABEL = { panel_first: "Painel + IA", ai_only: "Só IA", panel_only: "Só Painel" };

export const Header = ({ settings, onLogout }) => (
  <header className="border-b border-[#1F2937] bg-[#090D14]/90 backdrop-blur-xl sticky top-0 z-30">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="logo-mark"><Tv className="w-4 h-4" /><Bot className="w-4 h-4" /></div>
        <div className="min-w-0">
          <p className="font-heading font-bold text-lg leading-none truncate" data-testid="app-title">Bridge IPTV + IA</p>
          <p className="text-xs text-[#6B7280] mt-1 truncate">Auto Reply · WhatsApp · Painel</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {settings && (
          <span className="hidden sm:inline-flex mono-badge border-[#1F2937] text-[#9CA3AF]" data-testid="header-mode">
            {MODE_LABEL[settings.mode]}
          </span>
        )}
        <span className="status-pill" data-testid="header-status"><span className="dot" />Online</span>
        <button onClick={onLogout} className="chip flex items-center gap-1" data-testid="logout-button"><LogOut className="w-3.5 h-3.5" /><span className="hidden sm:inline">Sair</span></button>
      </div>
    </div>
  </header>
);
